"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoanInput = exports.defaultLoanInput = void 0;
const enums_1 = require("../../enums");
exports.defaultLoanInput = {
    agreementCode: '701',
    downPayment: 0,
    durationMonths: 60,
    ignoreCampaigns: false,
    investedAmount: 0,
    isElectricVehicle: true,
    isObjectDirectlyImported: false,
    isObjectNew: false,
    manualAdministrationFee: 0,
    manualNominalInterest: 0,
    objectGroupCode: '',
    objectMake: '',
    objectModel: '',
};
const getLoanInput = (override, customerType = enums_1.CustomerType.PRIVATE) => {
    return Object.assign(Object.assign(Object.assign({}, exports.defaultLoanInput), override), { objectGroupCode: customerType === enums_1.CustomerType.BUSINESS ? '702' : '701' });
};
exports.getLoanInput = getLoanInput;
//# sourceMappingURL=loan.js.map